import { Component, OnInit } from '@angular/core';
import {DialogRef} from "@progress/kendo-angular-dialog";
import {EmpresasService} from "../../superadmin/services/empresas.service";

@Component({
  selector: 'app-tela-gerenciar-papeis',
  templateUrl: './tela-gerenciar-papeis.component.html',
  styleUrls: ['./tela-gerenciar-papeis.component.scss']
})
export class TelaGerenciarPapeisComponent implements OnInit {
  empresa: any = {};
  windowRef: DialogRef;
  papeis: any = [];
  carregando = true;
  novoPapel: any;
  salvando: boolean;
  constructor(private empresasService: EmpresasService) { }

  ngOnInit(): void {
    this.empresasService.listePapeisComOperacoes(this.empresa).then((papeis) => {
      this.carregando = false;
      this.papeis = papeis;
    })
  }

  alterouOperacao(papel: any, operacao: any) {
    if(operacao.salvando ) return;

    operacao.salvando = true;

    this.empresasService.salveOperacaoDoPapel(this.empresa, papel, operacao).then(( ) => {
      operacao.salvando = false;
    }).catch((erro) => {
      operacao.salvando = false;
      operacao.ativa =  !operacao.ativa ;
      alert(erro)
    })

  }

  criarPapel() {
    this.novoPapel = {}
  }

  cancelarNovoPapel(){
    delete  this.novoPapel;
  }

  onSubmit() {
    this.salvando = true;
    this.empresasService.salvePapel(this.empresa, this.novoPapel).then((novoPapel: any) => {
      novoPapel.novo = true;
      this.papeis.splice(0, 0, novoPapel);
      delete  this.novoPapel;
      this.salvando = false;

    }).catch((erro) => {
      this.salvando = false;
      alert(erro)
    })
  }


}
